(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quality-work-gallery"] && !Shopify.designMode) return;
  try {
    
class QSWorkCarousel extends HTMLElement {
 connectedCallback(){
  if(this.controller)return;
  this.controller=new AbortController();
  const opts={signal:this.controller.signal};
  this.track=this.querySelector('.qs-work-gallery__track');
  this.prev=this.querySelector('[data-prev]');
  this.next=this.querySelector('[data-next]');
  this.count=this.querySelector('[data-count]');
  this.total=this.track.children.length;
  this.index=0;
  this.prev.addEventListener('click',()=>this.go(this.index-1),opts);
  this.next.addEventListener('click',()=>this.go(this.index+1),opts);
  this.track.addEventListener('scroll',()=>this.update(),{...opts,passive:true});
  this.track.addEventListener('keydown',e=>{
   if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.go(this.index+(e.key==='ArrowRight'?1:-1));}
  },opts);
  this.resize=new ResizeObserver(()=>this.update());
  this.resize.observe(this.track);
  this.update();
 }
 disconnectedCallback(){this.controller?.abort();this.resize?.disconnect();this.controller=null;}
 update(){
  const width=this.track.clientWidth;
  if(!width)return;
  this.index=Math.max(0,Math.min(this.total-1,Math.round(this.track.scrollLeft/width)));
  this.count.textContent=(this.index+1)+' / '+this.total;
  this.prev.disabled=this.index===0;
  this.next.disabled=this.index===this.total-1;
 }
 go(index){
  const i=Math.max(0,Math.min(this.total-1,index));
  this.track.scrollTo({left:i*this.track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
 }
}
if(!customElements.get('qs-work-carousel'))customElements.define('qs-work-carousel',QSWorkCarousel);

  } catch(e) { console.error(e); }
})();
})();
